export function windowFromBlob (blob, filename) {
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename)
  } else {
    window.open(URL.createObjectURL(blob))
  }
}

export function downloadFromBlob (blob, filename) {
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob, filename)
  } else {
    const container = document.getElementsByTagName('body')[0]
    const objectUrl = window.URL.createObjectURL(blob)
    const tag = document.createElement('a')
    tag.download = filename
    tag.href = objectUrl
    container.appendChild(tag)
    tag.click()
    container.removeChild(tag)
    window.URL.revokeObjectURL(objectUrl)
  }
}
